export enum UserRoleEnum {

    CUSTOMER = 1,
    SELLER = 2

}
